import { Popover } from '@headlessui/react';
import {
  AnalyticsEventAction,
  AnalyticsEventType,
} from '@th/shared/src/types/AnalyticsEvent';
import * as React from 'react';
import Avatar from '../../public/images/icons/avatar.svg';
import colors from '@th/shared/src/constants/colors';
import { AnimatePresence } from 'framer-motion';
import { useUser } from '../contexts/UserContext';
import logout from '../helpers/auth/logout';
import logEvent from '../helpers/mutations/logEvent';
import { useAuthModal } from '../contexts/AuthModalContext';
import SvgIcon from './icons/SvgIcon';

type Props = {};

function LoggedIn() {
  const { user } = useUser();
  return (
    <div className="flex flex-col gap-y-1 items-start">
      <p className="text-secondaryText">
        {user.name || user.email || user.phoneNumber}
      </p>
      <button
        onClick={() => {
          logout();
        }}
      >
        <p>Logout</p>
      </button>
    </div>
  );
}

function LoggedOut() {
  const { openAuthModal } = useAuthModal();
  return (
    <div className="flex flex-col gap-y-1 items-start">
      <button
        onClick={() => {
          logEvent({
            action: AnalyticsEventAction.clicked_signup_button_in_navbar_menu,
            type: AnalyticsEventType.signup_button_click,
          });
          openAuthModal();
        }}
      >
        <p className="font-bold">Sign up</p>
      </button>

      <button
        onClick={() => {
          logEvent({
            action: AnalyticsEventAction.clicked_login_button_in_navbar_menu,
            type: AnalyticsEventType.login_button_click,
          });
          openAuthModal();
        }}
      >
        <p>Login</p>
      </button>
    </div>
  );
}

export default function LoginPopover({}: Props) {
  const { isLoggedIn } = useUser();
  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button>
            <div className="flex flex-row items-center gap-x-3 px-2 py-1 border rounded-full hover:shadow hover:cursor-pointer">
              <SvgIcon name={'HiBars3'} className="h-5 w-5" />
              <div style={{ height: 30, width: 30 }}>
                <Avatar fill={colors.mediumGray} />
              </div>
            </div>
          </Popover.Button>
          <AnimatePresence initial={false}>
            {open && (
              <>
                <Popover.Overlay className="fixed inset-0 z-0 " />
                <Popover.Panel className="absolute right-0 z-10 mt-1 min-w-fit w-32 rounded-2xl shadow-2xl bg-gray-50">
                  <div className="m-4">
                    {isLoggedIn ? <LoggedIn /> : <LoggedOut />}
                  </div>
                </Popover.Panel>
              </>
            )}
          </AnimatePresence>
        </>
      )}
    </Popover>
  );
}
